'use client';

import { useSearchV2Sort } from '../hooks/useSearchV2Sort';
import { SortProps } from './Sort.types';
import { SortControl } from './SortControl';

export const Sort = ({ className }: SortProps) => {
  const { currentSortValue, sortCriteria, handleSort } = useSearchV2Sort();

  return (
    <SortControl
      currentSortValue={currentSortValue}
      sortCriteria={sortCriteria}
      onSort={handleSort}
      className={className}
    />
  );
};
